import { Box } from '@mui/material';
import { GuestJourneySlidingCards } from 'api/reports-service/guest-journey-reports.types';
import KpiCard from '../kpi-card/kpi-card.component';

export type SlidersSummaryCardsProps = {
  data?: GuestJourneySlidingCards;
  loading?: boolean;
};

// Card order is an FE decision — the BE response is keyed by metric name.
const CARD_ORDER: (keyof GuestJourneySlidingCards)[] = [
  'membersWhoOrdered',
  'sliders',
  'sliderRate',
  'medianDaysFromLastOrder',
  'projectedAnnualRevenue',
];

const SlidersSummaryCards = ({
  data,
  loading = false,
}: SlidersSummaryCardsProps) => (
  <Box
    display="grid"
    gap={2}
    gridTemplateColumns={{
      xs: '1fr',
      sm: 'repeat(2, 1fr)',
      md: 'repeat(3, 1fr)',
      lg: 'repeat(5, 1fr)',
    }}
    data-testid="Sliders.SummaryCards"
  >
    {CARD_ORDER.map(id => (
      <KpiCard
        key={id}
        card={data?.[id]}
        loading={loading}
        data-testid={`Sliders.SummaryCard.${id}`}
      />
    ))}
  </Box>
);

export default SlidersSummaryCards;
